import React from "react";
import { ImageKitProvider, Image } from "@imagekit/react";
import { imageKitUrl } from "../../env";
import { extractFullApiUrl } from "../../utils/HelperFunctions";


const ImageView = ({
  src,
  alt = "",
  width = 360,
  height = 240,
  breakpoints = [320, 480, 640, 960, 1280],
  sizes = "(max-width: 480px) 100vw, (max-width: 640px) 50vw, (max-width: 960px) 33vw, 25vw",
  transformation = [],
  className = "",
  loading = "lazy",
  objectFit = "fit",
  style={},
  ...rest
}) => {
  const finalSrc = extractFullApiUrl(src);
  
  return (
    <ImageKitProvider urlEndpoint={imageKitUrl}>
      <Image
        src={finalSrc}
        alt={alt}
        width={width}
        height={height}
        deviceBreakpoints={breakpoints}
        sizes={ sizes? sizes : undefined}
        loading={loading}
        className={className}
        transformation={[{ format: "auto", quality: "auto" }]}
        style={{
          objectFit,
          width: "100%",
          height: "100%",
          ...style,
        }}
        {...rest}
      />
    </ImageKitProvider>
  );
};

export default ImageView;
